import "../styles/Loading.css";

const Loading = () => {
	return (
		<main id="loading-container">
			<div id="container" style={{ justifyItems: "center" }}>
				<div className="loader" />
			</div>
		</main>
	);
};

export default Loading;

export const TableLoading = ({col = 1}) => {
	return (
		<tr>
			<td colSpan={col}>
				<Loading />
			</td>
		</tr>
	)
}
